var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_454_14661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.57143 0.5H21.4286C23.3929 0.5 25 2.10714 25 4.07143V21.9286C25 23.8929 23.3929 25.5 21.4286 25.5H3.57143C1.60714 25.5 0 23.8929 0 21.9286V4.07143C0 2.10714 1.60714 0.5 3.57143 0.5Z",
    fill: "#156CF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33337 15.1663C5.33337 12.1663 6.83337 9.16634 8.58337 9.16634C9.50004 9.16634 10.3334 9.74967 11.5834 11.4997C10.4167 13.2497 9.75004 14.4163 9.75004 14.4163C8.16671 16.833 7.66671 17.4163 6.75004 17.4163C5.83337 17.333 5.33337 16.583 5.33337 15.1663ZM15.5834 14.083L14.5 12.333C14.25 11.833 13.9167 11.4163 13.6667 10.9997C14.6667 9.49968 15.4167 8.74967 16.4167 8.74967C18.4167 8.74967 20 11.6663 20 15.2497C20 16.583 19.5834 17.4163 18.6667 17.4163C17.6667 17.333 17.25 16.7497 15.5834 14.083ZM12.75 9.74968C11.25 7.91634 10.0834 7.16634 8.58337 7.16634C5.58337 7.16634 3.33337 11.083 3.33337 15.1663C3.33337 17.7497 4.58337 19.333 6.66671 19.333C8.16671 19.333 9.25004 18.6663 11.1667 15.2497C11.1667 15.2497 12 13.833 12.5 12.833C12.6667 13.1663 12.9167 13.4997 13.0834 13.833L14 15.333C15.75 18.2497 16.75 19.2497 18.5 19.2497C20.5 19.2497 21.6667 17.583 21.6667 14.9997C21.6667 10.6663 19.3334 7.08301 16.5 7.08301C15 7.16634 13.8334 8.33301 12.75 9.74968Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_454_14661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeta);
export default __webpack_public_path__ + "static/media/meta.7c6a877151b6fcd300f459e4a42bf50d.svg";
export { ForwardRef as ReactComponent };